

import React, { useState } from 'react'
import dndItemTypes from '../../../constants/dndItemTypes'
import FlyerSmallPagePreview from './FlyerSmallPagePreview'
import Translation from '../../Translation/cont/Translation'
import FlyerDropzoneContainer from '../cont/FlyerDropzoneContainer'
import { GRID_IMAGE, IMAGE, METRO, MOVIE, MOVIE_PERFORMANCES, TEXT, TITLE } from '../../../constants/itemTypes'
import ListDrag from '../../DragAndDropList/presents/ListDrag'
import FlyerDragSwitch from './FlyerDragSwitch'
import FlyerPreviewContainer from '../../FlyerPreview/cont'
import MoviesFilterActionsContainer from '../../DragAndDropList/cont/MoviesFilterActionsContainer'
import ListToogleAllButtons from '../../DragAndDropList/presents/ListToogleAllButtons'
import ListToggleDisplayWrapper from '../../DragAndDropList/presents/ListToggleDisplayWrapper'


const filterConfig = [
    {
        id: 'genres',
        transId: 'movie_edit_movie_genres'
    },
    {
        id: 'technical',
        transId: 'section_filter_select_film_series_title_display'
    },
    {
        id: 'fsk',
        transId: 'movie_attributes_fsk'
    },
    {
        id: 'period',
        transId: 'section_filter_select_period_display_title'
    },
]



const FlyerSection = ({
    dragListConfig,
    isTitlePage,
    displayDropzones,

    cinemaId,
    printType,
    printFormat,
    landscape,
    week,
    section, 
    side, 

    relevantMoviesData,
    flyerData, 

    basicUrl,
    deleteFlyerCustomContent,
    addFlyerItem,
    deleteFlyerItem,
}) => {
    const [isAllOpen, setAllOpen] = useState(true)
    const displayDropzonesClass = displayDropzones ? ' dropzones' : ''

    return (
        <div className="program-page program-page-edit-selection site-content">
            <div className="selections-item">
                <div className="selections-item-content accordion-item">
                    <p className="selection-drag-hint title-large-light"><Translation id="section_page_drag_movies_to_sort"/></p>
                    <div className={"selections-item-selections section-left" + displayDropzonesClass}>
                        <FlyerSmallPagePreview
                            outside={false}
                            sectionActive={side + '-' + section}
                            side={side}
                            flyerStructureData={flyerData.flyerStructure}
                        />

                        <ListToogleAllButtons
                            setAllOpen={setAllOpen}
                        />

                        {dragListConfig.map(({
                            titleTransId,
                            buttonTextTransId,
                            type,
                            itemsType,
                            hasAddNewItem,
                            hasRemoveItem,
                        }, index) => {
                            let items = {}
                            let itemsOrder = []
                            let selectedItems = []
                            
                            if('currentMovies' === itemsType) {
                                items = relevantMoviesData.items
                                itemsOrder = relevantMoviesData.current
                                selectedItems = relevantMoviesData.selected
                            } else if('futureMovies' === itemsType) {
                                items = relevantMoviesData.items
                                itemsOrder = relevantMoviesData.future
                                selectedItems = relevantMoviesData.selected
                            } else {
                                items = flyerData[itemsType] ? flyerData[itemsType].items : null
                                itemsOrder = Object.keys(items)
                            }

                            return (
                                <div key={index}>
                                    {'currentMovies' === itemsType && (
                                        <ListToggleDisplayWrapper
                                            className=''
                                            titleTransId='movie_filter_actions_title'
                                            defaultIsOpen={isAllOpen}
                                            setAllOpen={setAllOpen}
                                        >
                                            <MoviesFilterActionsContainer
                                                filterConfig={filterConfig}
                                                // listId={}
                                                dropStructureData={false}
                                                relevantAttributes={relevantMoviesData.attributes}
                                                relevantMovies={relevantMoviesData.order}
                                                currentMovies={relevantMoviesData.current}
                                                futureMovies={relevantMoviesData.future}
                                                selectedItems={isTitlePage ? relevantMoviesData.order : selectedItems}
                                                addItem={(listId, itemId, targetId) => addFlyerItem(itemId, MOVIE, isTitlePage ? 'grid' : false)}
                                                deleteItem={(listId, itemId, targetId) => deleteFlyerItem(false, itemId, isTitlePage ? GRID_IMAGE : MOVIE_PERFORMANCES, isTitlePage ? 'grid' : false)}
                                            />
                                        </ListToggleDisplayWrapper>
                                    )}

                                    <ListDrag
                                        titleTransId={titleTransId}
                                        buttonTextTransId={buttonTextTransId}
                                        listId={side + '_' + section}
                                        type={type}
                                        dndType={dndItemTypes.FLYER_ITEM_AD}

                                        defaultIsOpen={isAllOpen}
                                        setAllOpen={setAllOpen}

                                        order={itemsOrder}
                                        items={items}
                                        className=''
                                        ChildSwitchItem={FlyerDragSwitch}
                                        selected={selectedItems}
                                        params={false}
                                        basicUrl={basicUrl}
                                        canEdit={true}
                                        canDelete={true}
                                        pathnameAdd={hasAddNewItem ? `${basicUrl}/${type}/addItem/form` : false}
                                        deleteItem={hasRemoveItem ? deleteFlyerCustomContent: null}
                                    />
                                </div>
                            )
                        })}

                    </div>


                    <div className={"selections-item-periodes custom-content section-center" + displayDropzonesClass}>
                            {isTitlePage ? (
                                <ul className="periode-list">
                                    <FlyerDropzoneContainer
                                        labelTransId={'print_flyer_title_grid'}
                                        flyerData={flyerData}
                                        section={section}
                                        side={side}
                                        area='grid'
                                        displayDropzones={displayDropzones}
                                        dndType={dndItemTypes.FLYER_ITEM_AD}
                                        canDropTypes={[MOVIE, IMAGE]}
                                        basicUrl={basicUrl}
                                        addFlyerItem={addFlyerItem}
                                        deleteFlyerItem={deleteFlyerItem}
                                        
                                    />

                                    <FlyerDropzoneContainer
                                        labelTransId={'print_flyer_title_content'}
                                        flyerData={flyerData}
                                        section={section}
                                        side={side}
                                        area='content'
                                        displayDropzones={displayDropzones}
                                        dndType={dndItemTypes.FLYER_ITEM_AD}
                                        canDropTypes={[TITLE, TEXT, IMAGE, METRO]}
                                        basicUrl={basicUrl}
                                        addFlyerItem={addFlyerItem}
                                        deleteFlyerItem={deleteFlyerItem}
                                    />
                                </ul>
                            ) : (
                                <ul className="periode-list">
                                    <FlyerDropzoneContainer
                                        labelTransId={null}
                                        flyerData={flyerData}
                                        section={section}
                                        side={side}
                                        area={false}
                                        dndType={dndItemTypes.FLYER_ITEM_AD}
                                        displayDropzones={displayDropzones}
                                        basicUrl={basicUrl}
                                        addFlyerItem={addFlyerItem}
                                        deleteFlyerItem={deleteFlyerItem}
                                    />
                                </ul>
                            )}
                    </div>

                    <div className="selections-item-periodes section-right">
                        <FlyerPreviewContainer
                            currentCinemaId={cinemaId}
                            activeWeek={week}
                            section={section}
                            side={side}
                           
                            printType={printType}
                            printFormat={printFormat}
                            landscape={landscape}
                            flyerData={flyerData}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FlyerSection